
export const serviceOptions = [
    "Custom Software",
    "Web App Development",
    "Mobile Apps",
    "UI/UX Design",
    "Cloud & DevOps",
    "AI & ML Integration",
    "QA & Testing",
    "IT Consulting",
    "Other",
];
